import React, { Component } from "react";

import { withRouter } from "react-router-dom";
import { inject, observer } from "mobx-react";

import Dropzone from "react-dropzone";

import {
    Grid, TextField, InputLabel, IconButton, Tooltip,
    Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, CircularProgress,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import AddPhotoAlternateIcon from "@material-ui/icons/AddPhotoAlternate";

import SearchActField from "../formFields/SearchActField";
import MultiSelectGenre from "../../fields/MultiSelectGenre";
import RichTextEditor from "../../richTextEditor/RichTextEditor";

const IS_MOBILE = process.env.REACT_APP_IS_MOBILE === "true";
const FILE_MAXSIZE = IS_MOBILE ? 8497152 : 2097152;
const ACCEPTED_FILE = "image/*";
const MAX_IMAGES = 6;
const PINK = "#ff0c9c";

@inject("gigPromotionStore", "templateStore")
@withRouter
@observer
class GigPromotionActDetails extends Component {

    state = {
        confirmImage: null,
        isDeleting: false,
    };

    handleActChange = value => {
        this.props.gigPromotionStore.setGigPromotion("act", undefined);
        this.props.gigPromotionStore.setGigPromotion("actId", undefined);
        this.props.gigPromotionStore.setGigPromotion("actName", value);
        this.setTempTitle();
    }

    handleSelectAct = act => {
        this.props.gigPromotionStore.setGigPromotion("actName", act.actName);
        this.props.gigPromotionStore.setGigPromotion("act", act);
        this.props.gigPromotionStore.setGigPromotion("actId", act.id);
        this.setTempTitle();
    };

    handleGenreChange = value => {
        this.props.gigPromotionStore.setGigPromotion("actGenres", value);
    }

    handleActVideoUrlChange = e => {
        this.props.gigPromotionStore.setGigPromotion("actVideoUrl", e.target.value);
    }

    handleActDescriptionChange = value => {
        this.props.gigPromotionStore.setGigPromotion("actDescription", value);
    }

    handleAddActImage = (files, rejectedFiles) => {
        if (rejectedFiles && rejectedFiles.length > 0) {
            let message = "";
            rejectedFiles.forEach(file => { message += file.name + ", "; });
            message = message.substr(0, message.length - 2);
            message += " couldn't be uploaded. Please check size and format.";
            this.props.templateStore.openSnackbar(message);
        }
        this.props.gigPromotionStore.addActImages(files);
    };

    requestDeleteActImage = image => {
        this.setState({ confirmImage: image });
    };

    handleConfirmDelete = () => {
        const { confirmImage } = this.state;
        if (!confirmImage) return;
        this.setState({ isDeleting: true });
        Promise.resolve(this.props.gigPromotionStore.deleteActImages(confirmImage)).then(() => {
            this.setState({ confirmImage: null, isDeleting: false });
        }).catch(() => {
            this.setState({ isDeleting: false });
            this.props.templateStore.openSnackbar("Failed to delete image. Please try again.");
        });
    };

    handleCancelDelete = () => {
        this.setState({ confirmImage: null, isDeleting: false });
    };

    setTempTitle = () => {
        const { gigPromotion } = this.props.gigPromotionStore;
        const { actName, venue, venueName } = gigPromotion;
        const title = `${actName} @ ${venue ? venue.profileName : venueName}`;
        this.props.gigPromotionStore.setGigPromotion("tempTitle", title);
    };

    render() {
        const { error, gigPromotion, actImages } = this.props.gigPromotionStore;
        const { actGenres, actName, actVideoUrl, actDescription } = gigPromotion;
        const { confirmImage, isDeleting } = this.state;

        return (
            <Grid container spacing={8}>
                <Grid item xs={12} lg={12} className="gridPrivateBookingForm">
                    <InputLabel shrink style={{ margin: 0 }}>Act</InputLabel>
                    <SearchActField
                        placeholder="Search Act"
                        id="private-booking-venue"
                        value={actName}
                        handleValueChange={this.handleActChange}
                        handleSelect={this.handleSelectAct}
                        error={error && error["act"]}
                        height={40}
                        helperText={error && error["act"] ? error["act"] : ""}
                    />
                </Grid>
                <Grid item xs={12}>
                    <MultiSelectGenre
                        id="search-genres"
                        onChange={this.handleGenreChange}
                        value={actGenres}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        id="videoUrl"
                        label="YouTube or Vimeo Url"
                        margin="dense"
                        placeholder="Add YouTube or Vimeo url"
                        fullWidth
                        value={actVideoUrl}
                        onChange={this.handleActVideoUrlChange}
                    />
                </Grid>
                <Grid item xs={12}>
                    <InputLabel style={{ color: error && error["actImages"] ? "#f44336" : undefined }}>
                        Act's Images ({actImages ? actImages.length : 0}/{MAX_IMAGES}) <span style={{ color: "#f44336" }}>*</span>
                    </InputLabel>
                    {error && error["actImages"] && (
                        <Typography variant="caption" style={{ color: "#f44336", display: "block", marginTop: 4 }}>
                            {error["actImages"]}
                        </Typography>
                    )}
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginTop: 8 }}>
                        {actImages && actImages.map((image, idx) => (
                            <div
                                key={image.id || image.url || idx}
                                style={{
                                    position: "relative",
                                    width: 130,
                                    height: 100,
                                    borderRadius: 6,
                                    overflow: "hidden",
                                    border: "1px solid rgba(0,0,0,0.12)",
                                    background: "#f5f5f5",
                                    flexShrink: 0,
                                }}
                            >
                                <img
                                    src={image.url}
                                    alt={image.name || image.fileName || `Image ${idx + 1}`}
                                    style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                                />
                                <div style={{
                                    position: "absolute", top: 0, right: 0,
                                    background: "rgba(0,0,0,0.6)", borderRadius: "0 0 0 6px",
                                }}>
                                    <Tooltip title="Delete image">
                                        <IconButton
                                            size="small"
                                            onClick={() => this.requestDeleteActImage(image)}
                                            style={{ padding: 4, color: "#fff" }}
                                        >
                                            <DeleteIcon style={{ fontSize: 18 }} />
                                        </IconButton>
                                    </Tooltip>
                                </div>
                            </div>
                        ))}
                        {(!actImages || actImages.length < MAX_IMAGES) && (
                            <Dropzone
                                accept={ACCEPTED_FILE}
                                maxSize={FILE_MAXSIZE}
                                onDrop={this.handleAddActImage}
                                style={{
                                    width: 130, height: 100, borderRadius: 6,
                                    border: "2px dashed rgba(0,0,0,0.2)",
                                    display: "flex", flexDirection: "column",
                                    alignItems: "center", justifyContent: "center",
                                    cursor: "pointer", background: "#fafafa",
                                    flexShrink: 0,
                                }}
                            >
                                <AddPhotoAlternateIcon style={{ color: "rgba(0,0,0,0.3)", fontSize: 28, marginBottom: 4 }} />
                                <span style={{ fontSize: 10, color: "rgba(0,0,0,0.4)", textAlign: "center", padding: "0 6px" }}>
                                    Add image<br />(max 2 MB)
                                </span>
                            </Dropzone>
                        )}
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <InputLabel shrink={true}>About Act</InputLabel>
                    <RichTextEditor
                        value={actDescription}
                        onChange={this.handleActDescriptionChange}
                    />
                </Grid>

                <Dialog open={!!confirmImage} onClose={this.handleCancelDelete} maxWidth="xs" fullWidth>
                    <DialogTitle>Delete Image</DialogTitle>
                    <DialogContent>
                        {confirmImage && confirmImage.url && (
                            <img
                                src={confirmImage.url}
                                alt="To be deleted"
                                style={{ width: "100%", maxHeight: 160, objectFit: "cover", borderRadius: 6, marginBottom: 12 }}
                            />
                        )}
                        <Typography variant="body2">
                            Are you sure you want to delete this image? This action cannot be undone.
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCancelDelete} disabled={isDeleting} style={{ textTransform: "none" }}>
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            onClick={this.handleConfirmDelete}
                            disabled={isDeleting}
                            style={{ backgroundColor: PINK, color: "#fff", textTransform: "none", boxShadow: "none" }}
                        >
                            {isDeleting
                                ? <><CircularProgress size={14} style={{ marginRight: 6, color: "#fff" }} />Deleting…</>
                                : "Delete"}
                        </Button>
                    </DialogActions>
                </Dialog>
            </Grid>
        );
    }
}

export default GigPromotionActDetails;
